import { BookOpen, ArrowRight } from 'lucide-react';

interface Step {
  title: string;
  description: string;
}

interface ExternalLink {
  href: string;
  text: string;
}

interface GettingStartedProps {
  title: string;
  description: string;
  steps: Step[];
  externalLink?: ExternalLink;
}

export default function GettingStarted({
  title,
  description,
  steps,
  externalLink,
}: GettingStartedProps) {
  return (
    <div className="mb-12 bg-gradient-to-br from-[#E34290]/5 to-purple-500/5 dark:from-[#E34290]/10 dark:to-purple-500/10 rounded-2xl p-8">
      <div className="max-w-3xl">
        <h2 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-4">{title}</h2>
        <p className="text-gray-600 dark:text-gray-400 mb-6">{description}</p>
        <div className="space-y-3 mb-6">
          {steps.map((step, index) => (
            <div key={index} className="flex items-start gap-3">
              <div className="w-6 h-6 bg-[#E34290] text-white rounded-full flex items-center justify-center text-sm font-medium mt-0.5">
                {index + 1}
              </div>
              <div>
                <span className="font-medium text-gray-900 dark:text-gray-100">{step.title}</span>
                <span className="text-gray-600 dark:text-gray-400 ml-2">{step.description}</span>
              </div>
            </div>
          ))}
        </div>
        {externalLink && (
          <a
            href={externalLink.href}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 text-[#E34290] hover:text-[#E34290]/80 font-medium transition-colors duration-200"
          >
            <BookOpen className="h-4 w-4" />
            {externalLink.text}
            <ArrowRight className="h-4 w-4" />
          </a>
        )}
      </div>
    </div>
  );
}
